import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a16ec2d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inner-page" }
const _hoisted_2 = {
  key: 1,
  class: "section-tenders"
}
const _hoisted_3 = { class: "tenders" }
const _hoisted_4 = { class: "tenders__list" }
const _hoisted_5 = {
  key: 0,
  class: "tender-title serp-header"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderSecondary = _resolveComponent("HeaderSecondary")!
  const _component_SearchMobile = _resolveComponent("SearchMobile")!
  const _component_SidebarSearch = _resolveComponent("SidebarSearch")!
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_EmptyCard = _resolveComponent("EmptyCard")!
  const _component_TenderCard = _resolveComponent("TenderCard")!
  const _component_ThePagination = _resolveComponent("ThePagination")!
  const _component_FooterMobile = _resolveComponent("FooterMobile")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_HeaderSecondary),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_SearchMobile),
      _createVNode(_component_SidebarSearch),
      _createElementVNode("main", null, [
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
          : _createCommentVNode("", true),
        (!_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  (!_ctx.isMobile && _ctx.currentRoute !== 'tenderSerp')
                    ? (_openBlock(), _createElementBlock("h1", _hoisted_5, _toDisplayString(_ctx.pageTitleHeader), 1))
                    : _createCommentVNode("", true),
                  (_ctx.getTenders.total == 0)
                    ? (_openBlock(), _createBlock(_component_EmptyCard, { key: 1 }))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getTenders.data, (tender) => {
                    return (_openBlock(), _createBlock(_component_TenderCard, {
                      tender: tender,
                      key: tender.id
                    }, null, 8, ["tender"]))
                  }), 128))
                ])
              ]),
              (_ctx.getTenders.total > 0)
                ? (_openBlock(), _createBlock(_component_ThePagination, {
                    key: 0,
                    maxPage: _ctx.getTenders.max_page
                  }, null, 8, ["maxPage"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_FooterMobile)
  ], 64))
}